/**
 * Sticky Header with Hide/Show on Scroll
 *
 * Hides the header when scrolling down and shows it when scrolling up.
 * Includes smooth animations for the show/hide behavior.
 *
 * @package Karuna_Hospice
 */

export function initStickyHeader() {
	if (typeof jQuery === 'undefined') {
		return;
	}

	const $ = jQuery;
	const scrollThreshold = 100; // Hide after scrolling 100px down
	let lastScrollY = 0;
	let ticking = false;

	$(document).ready(function() {
		const $header = $('#masthead');
		
		if (!$header.length) {
			return;
		}

		// Initialize header as visible
		$header.addClass('header-visible').removeClass('header-hidden');

		/**
		 * Updates header visibility based on scroll position
		 */
		function updateHeaderVisibility() {
			const currentScrollY = $(window).scrollTop();
			const scrollDelta = currentScrollY - lastScrollY;

			// Add/remove background classes based on scroll position
			if (currentScrollY > 0) {
				// Not at top - add background classes
				$header.addClass('max-lg:bg-black');
			} else {
				// At top - remove background classes
				$header.removeClass('max-lg:bg-black');
			}

			// Always show at the top (within threshold)
			if (currentScrollY <= scrollThreshold) {
				$header.removeClass('header-hidden').addClass('header-visible');
			}
			// Only hide/show if we're past the threshold
			else {
				// Scrolling down - hide header
				if (scrollDelta > 5) { // Small threshold to avoid jitter
					$header.removeClass('header-visible').addClass('header-hidden');
				}
				// Scrolling up - show header
				else if (scrollDelta < -5) { // Small threshold to avoid jitter
					$header.removeClass('header-hidden').addClass('header-visible');
				}
				// No significant change in scroll - keep current state
			}

			lastScrollY = currentScrollY;
			ticking = false;
		}

		/**
		 * Throttled scroll handler using requestAnimationFrame
		 */
		function onScroll() {
			if (!ticking) {
				window.requestAnimationFrame(updateHeaderVisibility);
				ticking = true;
			}
		}

		// Initialize lastScrollY after a brief delay to ensure page is loaded
		setTimeout(function() {
			lastScrollY = $(window).scrollTop();
			updateHeaderVisibility();
		}, 100);

		// Listen for scroll events
		$(window).on('scroll', onScroll);
	});
}

